var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _polygon, _path14, _polygon2, _polygon3, _polygon4, _polygon5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomer4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e0434867-4dbf-4b6d-811e-d575985e7b91",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 873.52708,
    height: 661.92224,
    viewBox: "0 0 873.52708 661.92224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b66d5b2e-2a7e-4a85-b9c3-ae278fa45bee",
    x1: 381.18245,
    y1: 172.59026,
    x2: 787.29187,
    y2: 172.59026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e0ad699f-4c97-4d99-9072-527ef1d2ca0a",
    x1: 381.18245,
    y1: 237.26667,
    x2: 787.29187,
    y2: 237.26667,
    xlinkHref: "#b66d5b2e-2a7e-4a85-b9c3-ae278fa45bee"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Checklist") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 251.77371,
    y: 206.3632,
    width: 24.20108,
    height: 31.11567,
    transform: "translate(355.71464 334.86139) rotate(-177.77929)",
    fill: "#0000ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.47458,314.79809s33.48948-16.00081,32.95362-2.182-33.75742,22.91021-33.75742,22.91021Z",
    transform: "translate(-163.23646 -119.03888)",
    fill: "#ffb9b9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343.10091,431.722s15.79986,38.67154,21.63752,66.57707,14.72813,66.30914,3.2923,93.54484-43.949,107.28243-44.28393,115.91918,2.78487,17.40747-4.12453,17.13953-44.5092-12.10567-46.0356-17.3547,12.82827-18.532,12.82827-18.532l35.44622-111.072-36.98273-72.362-26.6755,107.95227-5.22471,134.7333s-25.64232-7.91415-29.36495-1.13872c0,0-11.4886-16.015-12.948-22.99142S216.09091,584.222,216.09091,584.222s-23.53739-151.41816-4.53654-150.68135S304.97946,388.725,343.10091,431.722Z",
    transform: "translate(-163.23646 -119.03888)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M319.8902,717.99324s17.52722,38.73852,19.18758,40.53285,13.082,19.53672,4.44524,19.2018-29.03-9.77546-44.04032-24.19712-34.80071-39.40835-33.00638-41.06871,14.08673-6.37354,14.08673-6.37354Z",
    transform: "translate(-163.23646 -119.03888)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.85844,739.4968s1.05751,17.34049,4.24428,24.38385,2.78486,17.40747-5.85189,17.07255-30.95833-4.6604-30.95833-4.6604-1.32545-10.43108.46888-12.09145,9.44055-20.39328,6.1868-25.7093S249.85844,739.4968,249.85844,739.4968Z",
    transform: "translate(-163.23646 -119.03888)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237.08105,176.76838S218.66884,205.4635,211.4915,212.105s13.015,21.26407,13.015,21.26407l36.14038,4.86135s-.45466-32.88663,1.40666-36.27435S237.08105,176.76838,237.08105,176.76838Z",
    transform: "translate(-163.23646 -119.03888)",
    fill: "#ffb9b9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M268.49405,214.31542s-7.44527,13.55086-14.35467,13.28293S211.4915,212.105,209.9651,206.85593s-11.83773,37.5998-11.83773,37.5998l87.44934,153.89656,21.33105-14.74235L296.5721,293.25187l-8.48857-48.7677Z",
    transform: "translate(-163.23646 -119.03888)",
    fill: "#0000ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M206.73953,352.04644c3.4883,7.29728,5.667,14.907,5.36493,22.69736-.0134.34549-.02679.69088-.05748,1.0357-.82754,15.98724-6.71706,34.4769-8.83,47.92316-1.53317,9.64553-1.09685,16.686,4.54778,18.34081,13.68484,3.99056-1.99528,6.84241,50.94972,24.465s62.1846,2.4114,62.31857-1.0433-7.498-29.69986-5.7037-31.36023,25.10645,21.733,32.14981,18.54619.80381-20.7282.80381-20.7282S332.41611,394.97879,332.751,386.342s-24.03471-49.37055-24.03471-49.37055L292.14108,229.072s-6.37353-14.08674-14.94329-16.149-15.68012,2.85184-15.68012,2.85184L275.85812,247.47l15.13,55.945L288.457,324.07624s-17.5942-37.01117-29.14979-51.29885-36.19314-48.11209-36.19314-48.11209-5.752-19.40822-1.40981-25.20817c4.34286-5.81715-18.11269-6.68793-27.68721,17.16-5.07453,12.6394-13.31335,31.48776-18.47449,49.0369-4.59905,15.54682-6.77148,30.08066-2.21516,38.38812C180.29133,316.73326,197.80891,333.41457,206.73953,352.04644Z",
    transform: "translate(-163.23646 -119.03888)",
    fill: "#575a89"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.3274,304.0422c6.96393,12.69106,24.48151,29.37237,33.41213,48.00424,2.33258-8.40365,5.1782-17.09867,5.1782-17.09867s10.91418-58.395-21.3696-73.48647a21.60641,21.60641,0,0,0-15.00557,4.19278C170.94351,281.2009,168.77108,295.73474,173.3274,304.0422Z",
    transform: "translate(-163.23646 -119.03888)",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M301.48621,300.36222l27.36967,7.98114,38.0017,1.47363,3.90936,33.0206-62.45253,4.498S292.7155,303.482,301.48621,300.36222Z",
    transform: "translate(-163.23646 -119.03888)",
    fill: "#575a89"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85618,411.38785s36.61514,6.0748,28.25813,17.09327-40.79365-.56556-40.79365-.56556Z",
    transform: "translate(-163.23646 -119.03888)",
    fill: "#ffb9b9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M212.047,375.7795c-.82754,15.98724-6.71706,34.4769-8.83,47.92316,11.66423,11.03959,22.75619,20.77684,26.93635,20.93894,8.63675.33492,22.52253-.85656,27.6376,1.07174S265.906,414.889,265.906,414.889s-3.0528-10.49807-16.67065-16.216C240.04362,394.8047,222.42446,384.31269,212.047,375.7795Z",
    transform: "translate(-163.23646 -119.03888)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M190.95,251.0972s-29.231-4.59342-27.65182,43.90635-3.08124,79.4581,8.6753,88.56373,49.945,50.3753,58.58171,50.71022,22.52253-.85656,27.6376,1.07174,8.1151-30.82437,8.1151-30.82437-3.0528-10.49807-16.67065-16.216-45.70068-25.99146-45.43274-32.90086,8.1151-30.82436,8.1151-30.82436S223.23381,266.18868,190.95,251.0972Z",
    transform: "translate(-163.23646 -119.03888)",
    fill: "#575a89"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.62088,
    cy: 62.18896,
    r: 38.03026,
    fill: "#ffb9b9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M288.46407,126.7194a7.34333,7.34333,0,0,0,3.19762,1.60466c1.19735.1444,2.59994-.6265,2.64432-1.8317.8701,1.80446,1.85179,3.72762,3.62827,4.65352s4.52344.14951,4.77949-1.83734a8.38473,8.38473,0,0,0,1.92984,4.07362c1.10216,1.0509,3.101,1.31614,4.06326.13582-.778,4.25155-.2978,8.62384-.54211,12.93908s-1.395,8.89-4.65525,11.72759c-4.7547,4.13828-11.9046,3.117-18.159,2.33292a5.51183,5.51183,0,0,0-2.8457.15568c-2.34185.99772-2.23562,4.2577-2.26719,6.803-.11056,8.91433-7.67573,17.11868-16.55186,17.95034-2.47166.23158-5.1487-.11361-7.04244-1.71876-1.77578-1.50518-2.68286-3.95844-4.71768-5.08913-3.31-1.83927-7.32433.84309-9.74436,3.75554s-4.8051,6.495-8.55405,7.02815c-4.95822.7051-8.73462-4.34788-10.58739-9.00065a52.46983,52.46983,0,0,1,1.04277-40.76953C234.43545,117.06463,269.8011,113.49512,288.46407,126.7194Z",
    transform: "translate(-163.23646 -119.03888)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "194.425 122.009 873.527 8.825 873.527 342.986 194.425 364.545 194.425 122.009",
    fill: "#0000ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M492.40377,350.332c0-37.97132-17.06521-66.41574-37.72791-63.58559-20.246,2.77308-36.3613,34.64723-36.3613,71.24314s16.11534,65.13883,36.3613,63.72683C475.33856,420.27527,492.40377,388.30327,492.40377,350.332Z",
    transform: "translate(-163.23646 -119.03888)",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "787.292 165.126 381.182 210.152 381.182 184.937 787.292 135.028 787.292 165.126",
    fill: "url(#b66d5b2e-2a7e-4a85-b9c3-ae278fa45bee)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "787.292 229.803 381.182 274.829 381.182 249.613 787.292 199.704 787.292 229.803",
    fill: "url(#e0ad699f-4c97-4d99-9072-527ef1d2ca0a)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "258.7 233.84 273.683 231.534 288.667 246.518 305.956 214.245 324.398 214.245 288.667 259.197 258.7 233.84",
    fill: "#0000ff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "258.7 233.84 273.683 231.534 288.667 246.518 305.956 214.245 324.398 214.245 288.667 259.197 258.7 233.84",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer4);
export default __webpack_public_path__ + "static/media/customer4.1caf67ad590de158bae51833d2c55c06.svg";
export { ForwardRef as ReactComponent };